import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-attendance-request',
  templateUrl: './attendance-request.component.html',
  styleUrls: ['./attendance-request.component.css']
})
export class AttendanceRequestComponent implements OnInit {

  useType: boolean = false;
  output: any = [];
  allData: any = [];
  loaderShown = true;
  tableShown = false;
  count = 0;
  New_count = 0;
  next_output: any = [];

  // ✅ Dropdown options
  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Requested', value: 'Requested' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Rejected', value: 'Rejected' }
  ];

  // ✅ Default selection - Requested for initial load
  filterStatus: string = 'Requested';
  selectedRequests: Set<string> = new Set();
  selectAll: boolean = false;

  Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
});




  data = {
    _id: "",
    approve: false,
    status: ""
  };

  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe: any = null;

  constructor(
    private AdviceService: ServiceService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.useType = localStorage.getItem('userTypecon') === 'Admin';
    console.log("userType", this.useType);
  }

  // ✅ NEW: Toggle individual checkbox
toggleSelection(requestId: string, event: any) {
  if (event.target.checked) {
    this.selectedRequests.add(requestId);
  } else {
    this.selectedRequests.delete(requestId);
    this.selectAll = false;
  }
  console.log('Selected requests:', Array.from(this.selectedRequests));
}

// ✅ NEW: Check if a request is selected
isSelected(requestId: string): boolean {
  return this.selectedRequests.has(requestId);
}

// ✅ NEW: Toggle select all
toggleSelectAll(event: any) {
  this.selectAll = event.target.checked;
  this.selectedRequests.clear();
  
  if (this.selectAll) {
    this.output.forEach((item: any) => {
      if (item.status === 'Requested') {
        this.selectedRequests.add(item._id);
      }
    });
  }
  console.log('Select all:', this.selectAll, 'Selected:', Array.from(this.selectedRequests));
}

// ✅ NEW: Bulk approve selected requests
// ✅ Bulk approve selected requests - UPDATED
approveSelected() {
  if (this.selectedRequests.size === 0) {
    // alert('Please select at least one request to approve');
    this.Toast.fire({
  icon: 'warning',
  title: 'Please select at least one request to approve'
});
    return;
  }

  const idsToApprove = Array.from(this.selectedRequests);
  
  const biometricIds: string[] = [];
  const mobileIds: string[] = [];
  
  idsToApprove.forEach((id: string) => {
    const record = this.output.find((item: any) => item._id === id);
    if (record) {
      if (record.punching_type === 'Biometric Punching') {
        biometricIds.push(id);
      } else if (record.punching_type === 'Mobile Punching') {
        mobileIds.push(id);
      }
    }
  });
  
  const bulkUpdateData = {
    mobile_punching_ids: mobileIds,
    biometric_punching_ids: biometricIds,
    status: "Approved",
    approved_by_id: localStorage.getItem('admin_id') || '' // ✅ Changed to 'admin_id'
  };
  
  console.log('Bulk approving:', bulkUpdateData);
  
  
  // ✅ Changed to use bulkUpdateAttendanceRequest
  this.AdviceService.bulkUpdateAttendanceRequest(bulkUpdateData).subscribe(
    (res) => {
//       Swal.fire({
//   title: 'Approving...',
//   text: 'Please wait while we process the requests',
//   allowOutsideClick: false,
//   didOpen: () => {
//     Swal.showLoading();
//   }
// });
      console.log('Bulk approval response:', res);
      Swal.close();
      if (res.success) {
        Swal.close();
        // alert(`Successfully approved ${idsToApprove.length} requests!`);----------
        this.Toast.fire({
  icon: 'success',
  title: `Successfully approved ${idsToApprove.length} request${idsToApprove.length > 1 ? 's' : ''}!`
});
        this.selectedRequests.clear();
        this.selectAll = false;
        this.fetchDataWithFilter();
      } else {
        Swal.close();
        // alert('Failed to approve: ' + res.message);----------
        this.Toast.fire({
  icon: 'error',
  title: 'Failed to approve: ' + res.message
});

      }
    },
    (error) => {
      Swal.close();
      console.error('Bulk approval error:', error);
      // alert('Error approving requests');--------------
      this.Toast.fire({
  icon: 'error',
  title: 'Error approving requests'
});
    }
  );
}

  // ✅ Handle dropdown change (SERVER-SIDE filtering)
  onFilterChange(event: any) {
  const selected = event?.value;
  this.filterStatus = selected;
  console.log("Filter changed:", this.filterStatus);

  // Reset pagination when filter changes
  this.count = 0;
  this.New_count = 0;
  this.selectedRequests.clear(); 
  this.selectAll = false;       

  // Fetch data from server with the selected filter
  this.fetchDataWithFilter();
}

  // ✅ Fetch data with current filter from server
  fetchDataWithFilter() {
    this.loaderShown = true;
    this.tableShown = false;

    this.AdviceService.viewAttendanceRequest(this.count, this.filterStatus).subscribe((res) => {
      console.log("res", res);
      this.allData = res.data || [];
      this.output = [...this.allData]; // Directly use the server-filtered data
      this.loaderShown = false;
      this.tableShown = true;
    });
  }

  // ✅ Approve request
  // ✅ Update the Approve method
Approve(record: any) {
  console.log("✅ Approving record - Type:", record.punching_type, "ID:", record._id);
  
  const updateData: any = {
    _id: record._id,
    status: "Approved",
    approved_by_id: localStorage.getItem('admin_id') || ''
  };
  
  console.log("📤 Sending data:", updateData);
  
  let apiCall;
  
  if (record.punching_type === 'Biometric Punching') {
    apiCall = this.AdviceService.updateFactoryPunchingAdjustment(updateData);
    console.log("🔧 Using BIOMETRIC API (FactoryPunchingAdjustment)");
  } else if (record.punching_type === 'Mobile Punching') {
    apiCall = this.AdviceService.updateAttendanceRequest(updateData);
    console.log("📱 Using MOBILE API (AttendanceRequest)");
  } else {
    this.Toast.fire({
      icon: 'error',
      title: 'Unknown punching type: ' + record.punching_type
    });
    return;
  }
  
  Swal.fire({
    title: 'Approving...',
    text: 'Please wait',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });
  
  apiCall.subscribe(
    (res) => {
      console.log("📥 API Response:", res);
      Swal.close();
      if (res.success) {
        this.Toast.fire({
          icon: 'success',
          title: `${record.punching_type} request approved successfully!`
        });
        
        // ✅ ADD THESE LINES: Clear the selection for this item
        this.selectedRequests.delete(record._id);
        if (this.selectedRequests.size === 0) {
          this.selectAll = false;
        }
        
        this.fetchDataWithFilter();
      } else {
        Swal.close();
        this.Toast.fire({
          icon: 'error',
          title: `Failed to approve ${record.punching_type}: ${res.message}`
        });
      }
    },
    (error) => {
      console.error("❌ API Error:", error);
      Swal.close();
      this.Toast.fire({
        icon: 'error',
        title: `Error approving ${record.punching_type} request`
      });
    }
  );
}

Reject(record: any) {
  // const rejectReason = prompt('Please enter rejection reason:');
  
  // if (!rejectReason) {
  //   alert('Rejection reason is required');
  //   return;
  // }-------
  Swal.fire({
    title: 'Reject Request',
    input: 'textarea',
    inputLabel: 'Please enter rejection reason',
    inputPlaceholder: 'Enter reason for rejection...',
    inputAttributes: {
      'aria-label': 'Enter rejection reason'
    },
    showCancelButton: true,
    confirmButtonText: 'Reject',
    confirmButtonColor: '#d33',
    cancelButtonText: 'Cancel',
    inputValidator: (value) => {
      if (!value) {
        return 'Rejection reason is required!'
      }
      return null;
    }
  }).then((result) => {
    if (result.isConfirmed && result.value) {
      const rejectReason = result.value;
  
  console.log("❌ Rejecting record - Type:", record.punching_type, "ID:", record._id);
  
  const updateData: any = {
    _id: record._id,
    status: "Rejected",
    reject_reason: rejectReason,
    approved_by_id: localStorage.getItem('admin_id') || ''
  };
  
  console.log("📤 Sending data:", updateData);
  
  // Choose API based on punching type - SWITCHED!
  let apiCall;
  
  if (record.punching_type === 'Biometric Punching') {
    // BIOMETRIC uses FactoryPunchingAdjustment
    apiCall = this.AdviceService.updateFactoryPunchingAdjustment(updateData);
    console.log("🔧 Using BIOMETRIC API for rejection");
  } else if (record.punching_type === 'Mobile Punching') {
    // MOBILE uses AttendanceRequest
    apiCall = this.AdviceService.updateAttendanceRequest(updateData);
    console.log("📱 Using MOBILE API for rejection");
  } else {
    // alert('Unknown punching type: ' + record.punching_type);-------
    this.Toast.fire({
          icon: 'error',
          title: 'Unknown punching type: ' + record.punching_type
        });
    return;
  }
  // Show loading
      Swal.fire({
        title: 'Rejecting...',
        text: 'Please wait',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
  
  apiCall.subscribe(
    (res) => {
      console.log("📥 API Response:", res);
      Swal.close();
      if (res.success) {
  this.Toast.fire({
    icon: 'success',
    title: `${record.punching_type} request rejected successfully!`
  });
  
  // ✅ Clear the selection for this item
  this.selectedRequests.delete(record._id);
  if (this.selectedRequests.size === 0) {
    this.selectAll = false;
  }
  
  this.fetchDataWithFilter();
} else {
        // alert(`Failed to reject ${record.punching_type}: ${res.message}`);--------
        Swal.close();
        this.Toast.fire({
          icon: 'error',
          title: `Failed to reject ${record.punching_type}: ${res.message}`
        });
      }
    },
    (error) => {
      console.error("❌ API Error:", error);
      Swal.close();
      // alert(`Error rejecting ${record.punching_type} request. Check console.`);------
      this.Toast.fire({
        icon: 'error',
        title: `Error rejecting ${record.punching_type} request`
      });
    }
  );
  }
  });
  
}

  // ✅ Pagination - previous
  clicks_previous() {
    if (this.New_count == 0) {
      return;
    } else {
      this.New_count = this.New_count - 1;
      this.count = this.New_count;
    }
    // Pass current filter status to API
    this.AdviceService.viewAttendanceRequest(this.count, this.filterStatus).subscribe((res) => {
      this.allData = res.data;
      this.output = [...this.allData]; // Use server-filtered data directly
    });
  }

  // ✅ Pagination - next
  clicks_next() {
    this.count = this.count + 1;
    // Pass current filter status to API
    this.AdviceService.viewAttendanceRequest(this.count, this.filterStatus).subscribe((res) => {
      this.next_output = res.data;
      if (this.next_output.length != 0) {
        this.allData = this.next_output;
        this.output = [...this.allData]; // Use server-filtered data directly
        this.New_count = this.count;
      }
    });
  }

  // ✅ Date formatting
  DateFormat(value: any) {
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y');
    return this.todayWithPipe;
  }

  DateandtimeFormat(value: any) {
    this.todayWithPipe = this.pipe.transform(value, 'h:mm:ss a');
    return this.todayWithPipe;
  }

  // ✅ On init - load only Requested data from server initially
  ngOnInit(): void {
    // ✅ Debug: Check all localStorage keys
  console.log('All localStorage keys:');
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    console.log(`${key}: ${localStorage.getItem(key!)}`);
  }
    this.fetchDataWithFilter();
  }
}